/**
 * Generic type for constructors of classes. // rename me
 */
export type EventConstructor<T> = new (...args: any[]) => T;

/**
 * A class that represents an event with a type-safe payload.
 */
export abstract class Event<T> {
  constructor(public payload: T) {}
}

/**
 * A class that represents an event listener that listens for a specific event type.
 *
 * EventListeners must implement the `handle` method.
 */
export interface EventListener<T extends Event<any>> {
  handle(event: T): void;
}
